import { render, staticRenderFns } from "./ApprovedDeclinedButton.vue?vue&type=template&id=41daada5&scoped=true&"
import script from "./ApprovedDeclinedButton.vue?vue&type=script&lang=ts&"
export * from "./ApprovedDeclinedButton.vue?vue&type=script&lang=ts&"
import style0 from "./ApprovedDeclinedButton.vue?vue&type=style&index=0&id=41daada5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41daada5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
